import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { UpdateViewDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateShopView(shopId: string, viewId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);

  const mutation = $api.useMutation("patch", "/shops/{shopId}/views/{viewId}");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: (body: UpdateViewDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId, viewId } },
        body: body,
      });
    },
  });
}
